import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Title from '../../general/title'
import { Link } from 'react-router-dom'

class ThankYouClosing extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className="sale">
                <Title title="Congratulations!" />
                <div className="content">
                    <p>Click <Link to="/entry/closings/new-closing">here</Link> to add another closing or visit your <Link to="/entry/dashboard">Dashboard</Link>.</p>
                </div>
            </div>
        )
    }

}

function mapStateToProps(state) {
    return {
        
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ThankYouClosing)